// extracted by mini-css-extract-plugin
module.exports = {"outside":"Page_outside__3WbkH","container":"Page_container__3orHd","containerLarge":"Page_containerLarge__3YhXx"};